import React from 'react'
import { StyleSheet } from 'react-native'

import { Box, BoxBorder } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { FontSizes, Text } from 'widgets/Text'

import { SpacingTypes, ThemeColor } from 'utils/themes/types'

interface BorderButtonTypes {
  onPress?: () => void
  title?: string
  loading?: boolean
  disabled?: boolean
  link?: string
  width?: number
  height?: number
  fontSize?: FontSizes
  borderRadius?: SpacingTypes
  titleColor?: ThemeColor
  border?: BoxBorder
}

export const BorderButton = ({
  onPress,
  title,
  loading,
  disabled = false,
  link,
  width,
  height = 50,
  fontSize = 'md',
  borderRadius = 'xs',
  titleColor,
  border = { color: 'grey', width: 1 },
}: BorderButtonTypes) => {
  const styles = StyleSheet.create({
    textContainer: {
      opacity: loading || disabled ? 0.5 : 1,
    },
    text: {
      color: '#2D2D2D',
    },
  })

  return (
    <Pressable disabled={disabled || !onPress} onPress={onPress} link={link}>
      <Box
        width={width ?? undefined}
        height={height}
        borderRadius={borderRadius}
        padding={!width ? { horizontal: 'sm' } : undefined}
        backgroundColor='transparent'
        border={border}
        justifyContent='center'
        align='center'
        style={styles.textContainer}
      >
        <Text
          fontSize={fontSize}
          color={titleColor}
          style={titleColor ? undefined : styles.text}
          bold
        >
          {loading ? 'Loading...' : title}
        </Text>
      </Box>
    </Pressable>
  )
}
